export default {
  HEARTBEAT: 'HEARTBEAT',
  LOGOUT: 'LOGOUT',
  CONNECTION_ESTABLISHED: 'CONNECTION_ESTABLISHED',
  CONNECTION_LOST: 'CONNECTION_LOST',
  DEVICE_CREATED: 'DEVICE_CREATED',
  DEVICE_UPDATED: 'DEVICE_UPDATED',
  DEVICE_DELETED: 'DEVICE_DELETED'
}
